import styled from 'styled-components';
export var StyledVerticalTabs = styled.div.withConfig({
  displayName: "VerticalTabsstyles__StyledVerticalTabs",
  componentId: "sc-177anxl-0"
})(["display:flex;flex-direction:row;margin:var(--dentsu-spacing-28) 0;"]);